function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useMemo } from 'react';
import { FilterPicker, Checkbox, Typography } from 'seagull';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function VisibleColumnsPicker(props) {
  var _props$title, _props$type;
  const {
    fixedColumns,
    testId,
    visibleColumns,
    onApply: _onApply
  } = props;
  const [selectedColumns, setSelectedColumns] = useState(visibleColumns);
  const numSelectedColumns = useMemo(() => Object.values(selectedColumns).filter(value => value).length - Object.values(fixedColumns !== null && fixedColumns !== void 0 ? fixedColumns : {}).filter(value => value).length, [selectedColumns, fixedColumns]);
  const selectAll = useMemo(() => Object.values(selectedColumns).every(value => value), [selectedColumns]);
  return /*#__PURE__*/_jsxs(FilterPicker, {
    "data-testid": "".concat(testId, "-column-selector"),
    label: numSelectedColumns > 0 ? "".concat(numSelectedColumns, " columns selected") : 'None selected',
    title: props.type === 'button' ? (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : 'Additional columns' : 'Additional columns',
    highlightTrigger: false,
    onApply: () => _onApply(selectedColumns),
    onClose: () => {},
    type: (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'chip',
    prefixIcon: props.type === 'button' ? props.prefixIcon : undefined,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      checked: selectAll,
      onChange: () => {
        setSelectedColumns(Object.fromEntries(Object.entries(selectedColumns).map(_ref => {
          var _fixedColumns$name;
          let [name] = _ref;
          return [name, (_fixedColumns$name = fixedColumns === null || fixedColumns === void 0 ? void 0 : fixedColumns[name]) !== null && _fixedColumns$name !== void 0 ? _fixedColumns$name : !selectAll];
        })));
      },
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        children: "Select all"
      })
    }), Object.entries(selectedColumns).map(_ref2 => {
      let [name, selected] = _ref2;
      return /*#__PURE__*/_jsx(Checkbox, {
        name: name,
        disabled: fixedColumns === null || fixedColumns === void 0 ? void 0 : fixedColumns[name],
        "data-testid": "".concat(testId, "-column-picker-").concat(name.toLowerCase()),
        checked: !!selected,
        onChange: () => {
          setSelectedColumns(_objectSpread(_objectSpread({}, selectedColumns), {}, {
            [name]: !selected
          }));
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph1",
          children: name
        })
      }, name);
    })]
  });
}